import { useQuery } from '@tanstack/react-query';

import { Collections } from '@graylog/enterprise-api';

import type { CollectionDetail } from 'collections/types';
import { defaultOnError } from 'util/conditional/onError';

import { COLLECTIONS_QUERY_KEY } from './useCollections';

const getCollection = async ({ id }: { id: CollectionDetail['id'] }) => Collections.get(id);

const useCollection = (
  collectionId: CollectionDetail['id'],
  { enabled } = { enabled: true },
): {
  data: CollectionDetail;
  isLoading: boolean;
  refetch: () => void;
} => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [COLLECTIONS_QUERY_KEY, collectionId],
    queryFn: () =>
      defaultOnError(
        getCollection({ id: collectionId }),
        `Loading Collection ${collectionId} failed with status`,
        `Could not load Collection ${collectionId}`,
      ),
    enabled,
  });

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useCollection;
